export default "__VITE_ASSET__BILdrjXy__"